import React from 'react';
import { forwardToDynamicLink } from '../../global/utils/OhsMobileServices';
export const OhsTaskLinkMobileForward = () => {
  forwardToDynamicLink(window.location.href);
  return <></>;
};
